export var videoVariables = function videoVariables() {
  return {
    width: undefined,
    height: undefined
  };
};